/* import __COLOCATED_TEMPLATE__ from './custom-action-footer.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

const REQUEST_SECTION = 'request_section';
const RESPONSE_SECTION = 'response_section';
const TESTING_SECTION = 'testing_section';
const DATA_ACCESS_SECTION = 'data_access_section';
const OBJECT_MAPPING_SECTION = 'object_mapping_section';
const GENERAL_SECTION = 'general_section';
const CODE_BLOCKS_SECTION = 'code_blocks_section';

type SelectedTab =
  | typeof REQUEST_SECTION
  | typeof RESPONSE_SECTION
  | typeof TESTING_SECTION
  | typeof DATA_ACCESS_SECTION
  | typeof OBJECT_MAPPING_SECTION
  | typeof GENERAL_SECTION
  | typeof CODE_BLOCKS_SECTION;

interface Args {
  workflowAction: $TSFixMe;
  selectedTab: SelectedTab;
  onSelectionChange: (selectedTab: SelectedTab) => void;
}

interface Signature {
  Args: Args;
  Element: Element;
}

export default class CustomActionFooter extends Component<Signature> {
  @service declare intl: $TSFixMe;

  get isCodeBlockTransformationSuccess() {
    return this.args.workflowAction.isObjectMappingSectionEnabled;
  }

  get objectMappingSectionDisabledTooltip() {
    if (!this.isCodeBlockTransformationSuccess) {
      return this.intl.t(
        'workflow-connector.builder.body.code-blocks.test-code-before-object-mapping',
      );
    }
    return '';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::CustomActionFooter': typeof CustomActionFooter;
    'workflow-connector/custom-action-footer': typeof CustomActionFooter;
  }
}
